<section class="promo-categories">
  <div class="promo-categories__title">
    {{ 'HOME.HOME_PAGE.PROMO_TITLE' | translate }}
  </div>
  <!-- nested categories of promo drop-down menu -->
  <div class="promo-categories__promo-links">
    <div class="promo-categories__promo-links__link-container">
      <div class="promo-categories__promo-links__children">
        <a
          fxLayout="column"
          [routerLink]="isAllOffersFFEnabled ? allOffersRoute : ['/catalog']"
          [queryParams]="!isAllOffersFFEnabled && { 'f.promotion': true }"
          (click)="fireAllPromotionsClickEvent(selectedCategory?.name, 'HEADER.NESTED_CATEGORIES.SHOW')"
          class="promo-categories__promo-links__children__item"
        >
          <ng-container *ngIf="isAllOffersFFEnabled">
            {{ 'HOME.HOME_PAGE.HEADER.CATEGORIES.ALL_OFFERS' | translate }}
          </ng-container>
          <ng-container *ngIf="!isAllOffersFFEnabled">
            {{ 'HEADER.ALL_PAGES.HEADER.CATEGORIES.SHOW_ALL_PRODUCTS' | translate }}
            {{ 'HOME.HOME_PAGE.PROMO_TITLE' | translate }}
          </ng-container>
        </a>
        <ng-container *ngFor="let nested of selectedCategory.children; let i = index">
          <a
            fxLayout="column"
            *ngIf="i < MAX_VISIBLE_PROMOTIONS_MENU_ITEMS_COUNT"
            [routerLink]="[categoryRoute, nested?.slug]"
            [queryParams]="{ 'f.promotion': true }"
            (click)="firePromoCategoryClickEvent(nested?.name, selectedCategory?.name)"
            class="promo-categories__promo-links__children__item"
            [mmTestTarget]="'nested-category-link'"
          >
            {{ nested?.name }}
          </a>
        </ng-container>
      </div>
      <app-editorial-link-list
        *ngIf="editorialList"
        [editorialList]="editorialList"
        (menuClosed)="closeMenu()"
      ></app-editorial-link-list>
    </div>

    <app-menu-navigation-banner
      *ngIf="thematicResources"
      [thematicResources]="thematicResources"
      (menuClosed)="closeMenu()"
    ></app-menu-navigation-banner>
  </div>
</section>
